var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 35,
    rx: 10,
    transform: "matrix(1 0 0 -1 0 35.2285)",
    fill: "#F7801A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2248 23.1706C15.9807 22.9265 15.9807 22.5308 16.2248 22.2867C16.4688 22.0427 16.8646 22.0427 17.1087 22.2867L19.375 24.5531V14.3953C19.375 14.0502 19.6548 13.7703 20 13.7703C20.3452 13.7703 20.625 14.0502 20.625 14.3953V24.5531L22.8914 22.2867C23.1355 22.0427 23.5312 22.0427 23.7753 22.2867C24.0194 22.5308 24.0194 22.9265 23.7753 23.1706L20.4419 26.504C20.3247 26.6212 20.1658 26.687 20 26.687C19.8342 26.687 19.6753 26.6212 19.5581 26.504L16.2248 23.1706ZM15.2832 19.8377C15.4991 20.1071 15.4558 20.5004 15.1865 20.7163C14.9172 20.9322 14.5238 20.8889 14.3079 20.6196C13.3073 19.3714 12.7084 17.7858 12.7084 16.062C12.7084 12.0349 15.973 8.77032 20 8.77032C24.0271 8.77032 27.2917 12.0349 27.2917 16.062C27.2917 17.7858 26.6928 19.3714 25.6922 20.6196C25.4763 20.8889 25.0829 20.9322 24.8136 20.7163C24.5443 20.5004 24.501 20.1071 24.7169 19.8377C25.5461 18.8033 26.0417 17.4914 26.0417 16.062C26.0417 12.7253 23.3368 10.0203 20 10.0203C16.6633 10.0203 13.9584 12.7253 13.9584 16.062C13.9584 17.4914 14.454 18.8033 15.2832 19.8377Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.dad647e9f62e3a86031384ab899d15e6.svg";
export { ForwardRef as ReactComponent };